import { useRef, useState } from 'react';
import { MoreHorizontal, Trash2 } from 'lucide-react';
import { Button } from './ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from './ui/dropdown-menu';
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from './ui/alert-dialog';

export function ContentManagementMenu({
  kind,
  disabled,
  onRemove,
  onWithdraw,
}: {
  kind: 'blog' | 'case';
  disabled: boolean;
  onRemove: () => void;
  onWithdraw?: () => void;
}) {
  const [confirmation, setConfirmation] = useState<'withdraw' | 'delete'>('delete');
  const [open, setOpen] = useState(false);
  const trigger = useRef<HTMLButtonElement>(null);
  const label = kind === 'blog' ? 'het artikel' : 'de case';
  return (
    <>
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button ref={trigger} type="button" variant="outline" disabled={disabled}>
            <MoreHorizontal className="mr-2 h-4 w-4" />
            Meer
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end">
          {onWithdraw && (
            <>
              <DropdownMenuItem
                onSelect={() => {
                  setConfirmation('withdraw');
                  setOpen(true);
                }}
              >
                Publicatie intrekken
              </DropdownMenuItem>
              <DropdownMenuSeparator />
            </>
          )}
          <DropdownMenuItem
            className="text-destructive focus:text-destructive"
            onSelect={() => {
              setConfirmation('delete');
              setOpen(true);
            }}
          >
            <Trash2 className="mr-2 h-4 w-4" />
            Verwijderen
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>
      <AlertDialog open={open} onOpenChange={setOpen}>
        <AlertDialogContent
          onCloseAutoFocus={event => {
            event.preventDefault();
            trigger.current?.focus();
          }}
        >
          <AlertDialogHeader>
            <AlertDialogTitle>
              {confirmation === 'withdraw'
                ? 'Publicatie intrekken?'
                : kind === 'blog'
                  ? 'Artikel verwijderen?'
                  : 'Case verwijderen?'}
            </AlertDialogTitle>
            <AlertDialogDescription>
              {confirmation === 'withdraw'
                ? `Dit haalt ${label} van de website. De huidige wijzigingen worden als concept opgeslagen. Je kunt later opnieuw publiceren.`
                : `Dit verwijdert ${label} uit de backoffice en van de website. Dit kan niet ongedaan worden gemaakt.`}
            </AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogCancel>Annuleren</AlertDialogCancel>
            <AlertDialogAction
              disabled={disabled}
              className={
                confirmation === 'delete'
                  ? 'bg-destructive text-destructive-foreground hover:bg-destructive/90'
                  : undefined
              }
              onClick={() => {
                if (confirmation === 'withdraw') onWithdraw?.();
                else onRemove();
              }}
            >
              {confirmation === 'withdraw' ? 'Publicatie intrekken' : 'Verwijderen'}
            </AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </>
  );
}
